export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Transmissão de jogos da NBA ao vivo | NBA.com',
	seo_meta_desc_leaguepass: 'Assista a jogos ao vivo e a pedido com o NBA LEAGUE PASS. Aceda à sua conta aqui.',
	seo_meta_keywords_leaguepass: 'Vídeos da NBA, Destaques da NBA, Vídeos de Basquetebol, melhores lances, enterradas, recursos',
	seo_meta_title_featured: 'Veja os jogos da NBA & os destaques de cada jogo | NBA.com',
	seo_meta_desc_featured: 'Assista grátis aos destaques, notícias e análises em vídeo da NBA. Além disso, explore as assinaturas da NBA TV e League Pass para ver jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Veja jogos ao vivo e uma cobertura 24 horas por dia | NBA.com',
	seo_meta_desc_nbatv: 'Veja jogos da NBA TV ao vivo ou assista a jogos clássicos icónicos. Além disso, tenha acesso a programas de estúdio e análises de toda a liga.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, a batida, hardwood classics, nba em direto, nba real, hora de jogo nba, perceções da liga de fantasia, programas de estúdio, o salto',
	seo_meta_title_classicgames: 'Veja Jogos Clássicos com a NBA TV & mais | NBA.com',
	seo_meta_desc_classicgames: 'Veja batalhas icónicas da NBA com a NBA TV. Além disso, veja jogos da NBA TV ao vivo e obtenha acesso a programas de estúdio e análises de toda a liga.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Transmissão de conteúdo aqui | NBA.com',
	seo_meta_title_videolist: 'Transmissão {0} aqui | NBA.com',
	seo_meta_desc_videolist: 'Veja os vídeos {0} aqui. Além disso, explore as assinaturas para ver jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_title_videolist_show: 'Transmissões {0} da NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Veja {0} aqui. Além disso, veja jogos da NBA TV ao vivo e obtenha acesso a jogos clássicos e análises.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Transmissões {0} aqui | NBA.com',
	seo_meta_desc_videolist_feed: 'Veja os vídeos {0} aqui. Além disso, explore as assinaturas da NBA TV e League Pass para ver jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Veja programas de estúdio com a NBA TV & mais | NBA.com',
	seo_meta_desc_shows: 'Explore e veja os episódios e programas mais recentes da NBA TV a pedido. Além disso, veja jogos ao vivo na NBA TV e obtenha acesso a jogos clássicos e análises.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Home | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Canais | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Canal | NBA.com',
	seo_meta_pre_title_categories: 'Categorias | NBA.com',
	seo_meta_title_categories: 'Categorias | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Categoria | NBA.com',
	seo_meta_title_category: 'Categoria | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Transmissão de Vídeo Aqui | NBA.com',
	seo_meta_pre_title_event: 'Transmissão de Evento Aqui | NBA.com',
	seo_meta_title_events: 'Eventos | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Transmissão {0} Aqui | NBA.com',
	seo_meta_desc_event: 'Veja{0} aqui. Além disso, explore as assinaturas da NBA TV e League Pass para assistir a jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Pesquisa | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Página não encontrada | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Transmissão do Jogo Aqui | NBA.com',
	seo_meta_title_game: 'Transmissão {0} Aqui | NBA.com',
	seo_meta_desc_game: 'Veja{0} aqui. Além disso, explore as assinaturas da NBA TV e League Pass para ver jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Transmissão {0} Aqui | NBA.com',
	seo_meta_desc_video: 'Veja {0} aqui. Além disso, explore as assinaturas da NBA TV e League Pass para ver jogos ao vivo nos seus dispositivos favoritos.',
	seo_meta_keywords_video: 'Vídeos da NBA, Destaques da NBA, Vídeos de Basquetebol, melhores lances, enterradas, recursos',
	seo_meta_title_episode: 'Transmissão {0} na NBA TV | NBA.com',
	seo_meta_desc_episode: 'Veja{0} aqui. Além disso, assista a jogos da NBA TV ao vivo e obtenha acesso a jogos clássicos e análises.',
	seo_meta_keywords_episode: 'Vídeos da NBA, Destaques da NBA, Vídeos de Basquetebol, melhores lances, enterradas, recursos',
	seo_meta_title_channel: 'NBA TV ao vivo | NBA.com',
	seo_meta_desc_channel: 'O NBA TV em direto é a sua transmissão em direto 24 horas por dia do canal NBA TV com partidas em direto e arquivadas da NBA todas as semanas, programação do Estúdio e cobertura com analistas',
	seo_meta_keywords_channel: 'NBA TV Channel, a batida, hardwood classics, nba em direto, nba real, hora de jogo nba, perceções da liga de fantasia, programas de estúdio, o salto',
	seo_meta_title_tvguide: 'Programação das transmissões ao vivo da NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Veja quando ver transmissões de jogos da NBA TV ao vivo e programas de estúdio com a NBA TV no seu dispositivo favorito. Além disso, aceda a análises e programas de estúdio a pedido.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, a batida, hardwood classics, nba em direto, nba real, hora de jogo nba, perceções da liga de fantasia, programas de estúdio, o salto',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Ocorreu um erro, o conteúdo não está disponível de momento. Pode tentar de novo.',
	watch_in_app: 'VER NO APP DA NBA',
	ad_blocked_message: 'Bloqueador de anúncios detectado: o conteúdo de NBA.com é apoiado por publicidade. Para continuar a usufruir do nosso conteúdo, desative o seu bloqueador de anúncios.',

	// Item
	no_content: 'Sem Conteúdo',
	see_more: 'Ver Mais',
	now_playing: 'A TRANSMITIR AGORA',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Atingiu o número máximo de vídeos favoritos. Elimine alguns vídeos favoritos para poder adicionar mais.',
	item_live: 'EM DIRETO',
	add_favourite_title: 'ADICIONAR AOS FAVORITOS',
	remove_favourite_title: 'REMOVER DOS FAVORITOS',
	// Channel: Schedule
	p_channel_live: 'EM DIRETO',
	p_channel_schedule_title: 'Programação da NBA TV',
	p_channel_schedule_watch: 'Assistir',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Ver a programação completa',
	p_channel_live24x7_up_next: 'a seguir',
	p_channel_live24x7_on_demand: 'NBA TV: A pedido',
	p_channel_live24x7_collection: 'Coleção',
	p_channel_live24x7_demand_1_logo_text: 'Programas originais',
	p_channel_live24x7_demand_1_show_name: 'Programas da NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programas originais da NBA TV, incluindo \'Shaqtin \'a Fool\', \'Beyond the Paint\', \'Game Time\' e \'Basketball Stories\'',
	p_channel_live24x7_demand_2_logo_text: 'Jogos Clássicos',
	p_channel_live24x7_demand_2_show_name: 'NBA | Jogos Clássicos',
	p_channel_live24x7_demand_2_show_desc: 'Assista a jogos clássicos completos, incluindo todas as partidas das finais desde 2000, momentos históricos da liga e jogadores lendários.',

	// Channel: Clips
	p_channel_error_msg: 'Ainda não disponível',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programação',

	// NBA TV Shows:
	p_nba_tv_shows: 'Programas da NBA TV',
	p_nba_tv_no_access_title: 'NBA 24/7: mantenha-se informado com análises aos jogos, análises de estúdio, programação original e muito mais!',
	p_nba_tv_no_access_desc: 'Assista a jogos ao vivo, programas e jogos clássicos a pedido.',
	p_nba_tv_no_access_note: 'Podem ser aplicados bloqueios',

	// tv show item
	tv_show_item_latest_episode: 'Último episódio',
	tv_show_item_no_latest_episode: 'Nenhum último episódio',
	see_all: 'Ver tudo',
	// header
	header_menu_watch: 'Assistir',
	header_menu_featured: 'DESTAQUE',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Jogadores',
	videos: 'Vídeos',
	teams: 'Equipas',
	most_searched: 'MAIS PESQUISADAS',
	no_result: 'Sem dados',
	search_filter_type_most_relevant: 'Mais relevante',
	search_filter_type_most_viewed: 'Mais visto',
	search_filter_type_most_recent: 'Mais recente',
	search_filter_type_last_30_days: 'Últimos 30 dias',
	search_filter_type_last_6_months: 'Últimos 6 meses',
	search_result_label: 'Resultados da pesquisa para \'{keyword}\'',
	search_result_info: 'Mostrar todos os resultados para {keyword}',
	search_placeholder: 'Pesquise na videoteca',
	load_more: 'Carregar mais...',

	// button
	button_subscribe: 'Subscrever',
	button_sign_in: 'INICIAR SESSÃO',
	button_tv_provider: 'Selecione o fornecedor de TV',

	// league page
	p_league_pass_no_access_title: 'Assista aos jogos ao vivo ou em repetição em qualquer dispositivo, incluindo computador, smartphone e TV!',
	p_league_pass_no_access_desc: 'O seu bilhete para muita ação: veja a toda a liga ou a sua equipa favorita, escolha apenas um jogo ou consulte mais opções.',
	p_league_pass_no_access_note: 'São aplicáveis termos e condições',

	// Video
	category_title: 'Vídeo',
	p_video_playlist_title: 'Lista de reprodução:',
	p_video_episode_text: 'Episódio',
	p_no_access_league_pass_title: 'Desbloqueie o NBA League Pass para ver:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'O seu bilhete para muita ação: veja toda a liga ou a sua equipa favorita, escolha apenas um jogo ou consulte mais opções.',
	p_no_access_league_pass_terms: 'São aplicáveis termos e condições',
	p_no_access_league_pass_geo_desc: 'Baseado na sua localização atual, não é possível assistir a este jogo através do NBA League Pass e da NBA TV. Um arquivo desses jogos estará disponível 3 dias após a transmissão para os assinantes do NBA League Pass. Consulte os horários dos canais locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_league_pass_not_found_desc: 'Lamentamos, mas a página que solicitou não foi encontrada.',
	p_no_access_event_geo_desc: 'Esta transmissão não está disponível para os fãs nos Estados Unidos ou Canadá. Para assistir, sintonize a ESPN nos EUA e a TSN ou Sportsnet no Canadá.',
	p_no_access_event_not_found_desc: 'Lamentamos, mas o evento que solicitou não foi encontrado.',
	p_no_access_nba_tv_title: 'Desbloqueie a NBA TV para ver:',
	p_no_access_nba_tv_desc: 'Veja jogos ao vivo , outros programas e jogos clássicos a pedido.',
	p_no_access_nba_tv_terms: 'São aplicáveis termos e condições',
	p_no_access_nba_tv_geo_desc: 'Com base na sua localização atual, não é possível ver  este jogo através do NBA League Pass e da NBA TV. Uma gravação destes jogos estará disponível 3 dias após a transmissão para os assinantes do NBA League Pass. Consulte os horários dos canais locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_nba_tv_not_found_desc: 'Lamentamos, mas a página que solicitou não foi encontrada.',
	p_no_access_up_next: 'A seguir:',
	p_video_completed_title: 'Lista de reprodução completa',
	p_video_completed_desc: 'Volte para navegar ou verifique a lista de reprodução seguinte para si',
	p_video_share_to: 'Partilhar com:',
	p_video_more_to_watch: 'Mais para ver:',

	// Event
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Lista de reprodução:',
	p_event_button_watch: 'Assistir',
	p_event_button_listen: 'Ouvir',
	p_event_button_ticket: 'Bilhete',

	// notfound page
	notfound: 'Lamentamos, mas a página que solicitou não foi encontrada.',
	notfound_desc: 'Verifique se há erros no URL. <br/> Também pode tentar utilizar a ferramenta de navegação ou de pesquisa no site para encontrar o conteúdo.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'A sua conta da NBA League Pass atingiu o número máximo de transmissões. Clique em \'Continuar\' para assistir neste dispositivo.',
	modal_pcm_custom: 'Continuar',
	modal_pcm_close: 'Cancelar',
	modal_pcm_ok: 'OK',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Este vídeo não pode ser reproduzido no seu dispositivo. Clique  <a href=\'https://protect-us.mimecast.com/s/GBYOCNk7K2i0xMz8ocm17hd?domain=neulion-a.akamaihd.net\' target=\'_blank\'>AQUI</a> para obter mais ajuda.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	modal_video_unsupported_ok: 'OK',

	// FreeSample
	freesample_notice_time: 'Tempo restante',
	freesample_notice_title: 'Aproveite os seus {0} minutos de acesso',
	freesample_notice_desc: 'Subscreva um League Pass integral para continuar a aceder aos conteúdos após os {0} minutos.',
	freesample_notice_subscribe_button: 'Subscrever',
	freesample_notice_cancel_button: 'CANCELAR A QUALQUER MOMENTO',
	freesample_popup_title: 'O SEU ACESSO TERMINOU',
	freesample_popup_subtitle: 'Subscreva o League Pass para assistir a ainda mais conteúdos da NBA.',
	freesample_popup_link: 'SAIBA MAIS!',
	freesample_popup_get_minutes_button: 'OBTENHA {0}  MINUTOS',

	// Video list
	reg_required_desc: 'Precisa de iniciar sessaõ para ver este conteúdo',
	favorite_teams_title: 'Equipas Fav',
	bookmarked_title: 'Guardado',
	watch_history_title: 'Continue a ver',
	game_schedule_title: 'Programação dos jogos',
	recommended_title: 'Recomendado',
	season_text: 'Temporada',

	// profile page
	section_information_title: 'As minhas informações',
	section_information_desc: 'Atualize os seus dados pessoais',
	section_information_email: 'E-mail',
	section_information_email_update: 'Atualizar endereço de e-mail',
	section_information_password: 'Palavra-passe',
	section_information_password_update: 'Alterar a palavra-passe',
	section_information_social: 'Redes sociais',
	section_information_nosocial_message: 'Não possui contas associadas.',
	section_information_firstname: 'Nome próprio',
	section_information_lastname: 'Apelido',
	section_information_birth: 'Data de nascimento',
	section_information_country: 'País/Região',
	section_information_postalcode: 'Código postal',
	section_information_edit: 'Editar',
	section_tv_provider_title: 'O meu fornecedor de TV',
	section_tv_provider_desc: 'Obtenha acesso a jogos e transmissões ao vivo através do seu fornecedor de TV.',
	section_tv_provider_faq: 'Perguntas frequentes sobre o fornecedor de TV',
	section_tv_provider_sign_out: 'Terminar sessão',
	section_tv_provider_sign_in: 'Entrar no Fornecedor de TV',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'Ver os dados da sua conta fantasy',
	section_fantasy_displayname: 'Nome a apresentar',
	section_marketing_title: 'Preferências de E-mail',
	section_marketing_desc: 'Visualize as preferências das suas comunicações de marketing e as preferências de privacidade de utilizador',
	section_marketing_newsletters: 'Newsletters',
	section_marketing_message: 'Mensagens e anúncios da NBA',
	section_marketing_newsletters_desc_1: 'Notícias da NBA entregues diariamente na sua caixa de correio',
	section_marketing_newsletters_desc_2: 'Notícias da NBA G League e Recursos da liga secundária oficial da NBA.',
	section_marketing_newsletters_desc_3: 'Notícias da Jr. NBA e conteúdo de basquetebol júnior da NBA.',
	section_marketing_newsletters_desc_4: 'Os recursos mais recentes na aplicação da NBA, juntamente com atualizações e ofertas do League Pass',
	section_marketing_newsletters_desc_5: 'Ofertas especiais de bilhetes, ofertas de parceiros, eventos e descontos no merchandising da NBA.',
	section_marketing_newsletters_desc_6: 'Notícias e conteúdo da NBA selecionado e entregue semanalmente na sua caixa de correio',
	section_marketing_newsletters_desc_7: 'Notícias e ofertas da WNBA e dos seus parceiros',
	section_marketing_personal_title: 'Os Meus Dados Pessoais',
	section_marketing_personal_desc: 'Por favor, use as minhas informações pessoais para que a NBA me envie mensagens e anúncios sobre produtos e iniciativas da NBA e da NBA Partners.',
	section_marketing_update_button: 'Atualização das Preferências de Marketing.',
	section_marketing_update_success: 'As suas preferências foram atualizadas.',
	section_ccpa_title: 'Não vender os meus dados pessoais',

	// profile edit modal
	email_modal_title: 'atualizar o endereço de e-mail',
	email_modal_new_email_label: 'novo endereço de e-mail',
	email_modal_update: 'Atualizar',
	email_modal_cancel: 'Cancelar',
	password_modal_title: 'Alterar a palavra-passe',
	password_modal_current_label: 'Palavra-passe atual:',
	password_modal_new_label: 'Nova palavra-passe:',
	password_modal_confirm_label: 'Confirmar palavra-passe',
	password_modal_update: 'Atualizar',
	password_modal_cancel: 'Cancelar',
	personal_modal_title: 'atualizar dados pessoais',
	personal_modal_email: 'E-mail',
	personal_modal_password: 'Palavra-passe',
	personal_modal_birth: 'Data de nascimento',
	personal_modal_social: 'Redes sociais',
	personal_modal_firstname: 'Nome próprio',
	personal_modal_lastname: 'Apelido',
	personal_modal_country: 'País/Região',
	personal_modal_postalcode: 'Código postal',
	personal_modal_zipcode: 'Código postal',
	personal_modal_postalcode_invalid_message: 'Tem de ser um código postal válido',
	personal_modal_zipcode_invalid_message: 'Tem de ser um código postal válido',
	personal_modal_update: 'Atualizar',
	personal_modal_cancel: 'Cancelar',

	// payflow
	payflow_profile_name: 'Nome',
	payflow_profile_email: 'E-mail',

	// account page
	header_menu_account_my_account: 'A minha conta',
	header_menu_account_manage_account: 'Gerir conta',
	header_menu_account_favorite_teams: 'Equipas Favoritas',
	header_menu_account_favorite_players: 'Jogadores Favoritos',
	header_menu_account_viewing_history: 'Histórico de visualizações',
};
